import { refreshAsync } from 'expo-auth-session';

import { config } from '../../config';

/**
 * Retrieves a fresh access token for our API, using the locally stored refresh token.
 *
 * @see https://docs.expo.dev/versions/latest/sdk/auth-session/#authsessionfetchdiscoveryasyncissuer
 * @see https://docs.expo.dev/versions/latest/sdk/auth-session/#authsessionrefreshasyncconfig-discovery
 */
export async function refreshAccessTokens(
  refreshToken: string | undefined,
): RefreshAccessTokensResolveType {
  if (!refreshToken) {
    throw new Error('No refresh token was found');
  }

  const { clientId, scopes, discovery } = config;

  const apiAccessTokenRequest = {
    clientId,
    refreshToken,
    scopes: scopes.apiLoginRequest.scopes,
  };

  const { accessToken: apiAccessToken } = await refreshAsync(apiAccessTokenRequest, discovery);

  if (!apiAccessToken) {
    throw new Error('Failed to retrieve access token');
  }

  return { apiAccessToken };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type RefreshAccessTokensResolveType = Promise<{
  apiAccessToken: string;
}>;
